import { ref, watch } from 'vue'

const loadData = (key) => {
  const dataJSON = localStorage.getItem(key)

  let data

  try {
    data = JSON.parse(dataJSON)
  } catch {
    data = null
  }

  return data || {}
}

const useStoredRef = (defaultValue, key, subKey) => {
  const data = loadData(key)
  const storedValue = data[subKey]

  const syncedRef = ref(storedValue !== undefined ? storedValue : defaultValue)

  watch(syncedRef, () => {
    const data = loadData(key)

    data[subKey] = syncedRef.value

    localStorage.setItem(key, JSON.stringify(data))
  }, { deep: true })

  return syncedRef
}

export const cleanupStoredRefs = (key, subKeysToKeep = []) => {
  const data = loadData(key)
  const newData = {}

  subKeysToKeep.forEach((subKey) => {
    if (Object.hasOwn(data, subKey)) {
      newData[subKey] = data[subKey]
    }
  })

  localStorage.setItem(key, JSON.stringify(newData))
}

export default useStoredRef
